module.exports = __webpack_public_path__ + "img/icone-agentes.863515c2.svg";